import { HeadingMedium, LockIcon } from '@arnold/common';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import PublicLayout from '../../components/Common/PublicLayout';
import storage from '../../lib/storage';
import { RoundLogo } from '../Login/Common';
import LoginAside from '../Login/LoginAside';
import ChangePasswordForm from './ChangePasswordForm';

interface ILocationState {
  accessToken: string;
}
interface ILocation extends Location {
  state: ILocationState;
}
interface IProps extends RouteComponentProps<any> {
  location: ILocation;
}

const ChangePasswordScreen = ({ match, history }: IProps) => {
  const [t] = useTranslation('changePasswordForm');
  const { accessToken, lang } = match.params;
  const detectedLang = lang || storage.getDetectedLanguage()?.substring(0, 2);

  return (
    <PublicLayout
      basePath={`changePassword/${accessToken}`}
      history={history}
      lang={detectedLang}
      aside={<LoginAside />}
    >
      <>
        <RoundLogo>
          <LockIcon />
        </RoundLogo>
        <HeadingMedium className="text-center">{t('changePassword')}</HeadingMedium>
        <ChangePasswordForm lang={detectedLang} />
      </>
    </PublicLayout>
  );
};

export default ChangePasswordScreen;
